import { render } from "./ServicosDropdown.vue?vue&type=template&id=32cef084"
import script from "./ServicosDropdown.vue?vue&type=script&lang=js"
export * from "./ServicosDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__